import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Navimumbaiinternatinalairport() {



  const cardData = {



keyword: "Navi Mumbai International Airport Cabs",

headingDescription: "Garud Cab Service provides comfortable and reliable Navi Mumbai International Airport Cabs for business travelers, families, tourists, senior citizens, students, and groups looking for convenient airport transportation. Customers can book chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, Tempo Traveller, and other suitable vehicles for airport pickup and drop, hotel transfers, corporate travel, railway station transfers, residential transportation, intercity journeys, and customized travel plans. With experienced drivers, clean and well-maintained vehicles, comfortable seating, spacious luggage areas, flight-based pickup coordination, flexible pickup locations, transparent pricing, and 24/7 customer assistance, Garud Cab Service makes airport travel smooth and convenient. Travelers can arrange direct transfers to Navi Mumbai, Mumbai, Pune, business parks, residential areas, hotels, railway stations, and popular outstation destinations according to their preferred schedule.",

topPlaces: [
  {
    title: "Navi Mumbai Airport",
    description: "Navi Mumbai International Airport is an important aviation hub serving Navi Mumbai and surrounding regions. Travelers can arrange comfortable cab transfers for airport pickup and drop, hotel transportation, corporate travel, railway station connections, and onward journeys. Garud Cab Service provides suitable vehicles with professional chauffeurs, flexible timings, and convenient luggage space."
  },
  {
    title: "Mumbai Airport",
    description: "Mumbai Airport is a major aviation gateway for travelers arriving in or departing from the Mumbai Metropolitan Region. Passengers can book private cabs between Navi Mumbai International Airport and Mumbai Airport for connecting flights, business travel, and personal journeys. Comfortable vehicles and flexible scheduling make airport-to-airport transfers convenient."
  },
  {
    title: "Pune Airport",
    description: "Pune Airport is an important airport serving travelers from Pune and nearby business and residential areas. Customers arriving at Navi Mumbai International Airport can arrange direct cab transportation to Pune Airport for connecting flights or onward travel. Garud Cab Service offers spacious vehicles suitable for passengers traveling with luggage."
  },
  {
    title: "Panvel",
    description: "Panvel is one of the closest major transportation hubs to Navi Mumbai International Airport and provides connectivity toward Mumbai, Pune, and other Maharashtra destinations. Airport passengers can book direct cabs to Panvel railway station, hotels, offices, or residential areas. Flexible pickup and drop options are available for individual travelers and groups."
  },
  {
    title: "Vashi",
    description: "Vashi is a major commercial and residential destination in Navi Mumbai and is frequently accessed by airport passengers for business, hotel stays, shopping, and residential travel. A private airport cab provides convenient door-to-door transportation from Navi Mumbai International Airport. Customers can select vehicles according to passenger and luggage requirements."
  },
  {
    title: "Belapur",
    description: "Belapur is an important business and administrative destination in Navi Mumbai with corporate offices, hotels, government establishments, and residential communities. Travelers arriving at Navi Mumbai International Airport can arrange direct cab transportation to Belapur. Garud Cab Service provides professional drivers and comfortable vehicles for scheduled airport transfers."
  },
  {
    title: "Kharghar",
    description: "Kharghar is a major residential and commercial locality near Navi Mumbai International Airport, attracting families, students, professionals, and business travelers. Customers can book an airport cab for direct transportation between Kharghar and the airport. Sedan, SUV, Ertiga, Innova, and Innova Crysta options are available according to travel needs."
  },
  {
    title: "Nerul",
    description: "Nerul is a well-connected Navi Mumbai locality with residential communities, commercial establishments, educational institutions, and railway connectivity. Airport passengers can conveniently arrange private cab transfers between Nerul and Navi Mumbai International Airport. Flexible pickup timings and spacious luggage areas make the journey comfortable."
  },
  {
    title: "Thane",
    description: "Thane is a major city in the Mumbai Metropolitan Region and is frequently connected with Navi Mumbai for business, residential, and airport travel. Customers can arrange direct cab transportation from Navi Mumbai International Airport to Thane without changing vehicles. Garud Cab Service provides comfortable long-distance airport transfers with flexible drop locations."
  },
  {
    title: "Pune",
    description: "Pune is a major technology, corporate, educational, and residential destination connected to Navi Mumbai through important road routes. Travelers arriving at Navi Mumbai International Airport can book direct airport-to-Pune cab transportation for convenient door-to-door travel. Spacious vehicles are suitable for families, corporate groups, and passengers carrying luggage."
  }
],




"services": [
  {
    "name": "Cab Service in Navi Mumbai International Airport",
    "description": "Cab Service in Navi Mumbai International Airport provides convenient transportation for passengers arriving at or departing from NMIA. Sedan, SUV, Ertiga, Innova, and premium cab options can be arranged for airport pickups, drops, local travel, outstation journeys, corporate travel, and family transportation."
  },
  {
    "name": "Navi Mumbai International Airport Cab",
    "description": "Navi Mumbai International Airport Cab offers comfortable private transportation with scheduled pickup and drop facilities. Passengers can choose suitable vehicles according to their luggage, group size, destination, and airport travel requirements."
  },
  {
    "name": "Navi Mumbai International Airport Taxi",
    "description": "Navi Mumbai International Airport Taxi service is suitable for travelers looking for convenient transportation to and from the airport. AC sedans, SUVs, Ertiga, and Innova vehicles can be arranged for individuals, families, business travelers, and groups."
  },
  {
    "name": "NMIA Cab Service",
    "description": "NMIA Cab Service provides reliable airport transportation for passengers traveling to residential areas, hotels, offices, railway stations, and outstation destinations. Flexible vehicle options make the service suitable for different passenger and luggage requirements."
  },
  {
    "name": "NMIA Taxi Service",
    "description": "NMIA Taxi Service offers private airport transportation with convenient pickup and drop arrangements. The service can be used for airport transfers, local Navi Mumbai travel, business trips, family journeys, and long-distance transportation."
  },
  {
    "name": "Airport Cab Navi Mumbai International Airport",
    "description": "Airport Cab Navi Mumbai International Airport is suitable for passengers requiring comfortable transportation after arrival or before departure. Professional drivers and suitable AC vehicles can be arranged for airport transfers, hotels, offices, and outstation destinations."
  },
  {
    "name": "Taxi Service at Navi Mumbai International Airport",
    "description": "Taxi Service at Navi Mumbai International Airport helps passengers arrange convenient private transportation from the airport to their preferred destination. Sedan, SUV, Ertiga, and Innova options can accommodate different travel requirements."
  },
  {
    "name": "Navi Mumbai International Airport Cab Booking",
    "description": "Navi Mumbai International Airport Cab Booking allows travelers to arrange their airport transportation in advance according to flight schedules and pickup requirements. Suitable vehicles can be selected for solo passengers, families, corporate travelers, and groups."
  },
  {
    "name": "NMIA Taxi Booking Online",
    "description": "NMIA Taxi Booking Online provides a convenient way to arrange airport transportation before reaching Navi Mumbai International Airport. Passengers can plan pickups and drops according to their travel schedule and choose a suitable vehicle category."
  },
  {
    "name": "Navi Mumbai International Airport Cab Fare",
    "description": "Navi Mumbai International Airport Cab Fare depends on factors such as destination, vehicle category, travel requirements, and journey type. Customers can select from sedan, Ertiga, SUV, Innova, and premium cab options according to their needs."
  },
  {
    "name": "NMIA Taxi Charges",
    "description": "NMIA Taxi Charges can vary based on the travel distance, vehicle selected, airport pickup or drop requirement, and journey type. Different vehicle categories can be arranged for individuals, families, corporate travelers, and groups."
  },
  {
    "name": "Navi Mumbai International Airport Cab Price",
    "description": "Navi Mumbai International Airport Cab Price depends on the selected vehicle and destination. Travelers can choose economical sedans, spacious Ertiga and SUVs, or premium Innova options for comfortable airport transportation."
  },
  {
    "name": "Best Cab Service at NMIA",
    "description": "Best Cab Service at NMIA is designed for travelers seeking comfortable and convenient airport transportation. Well-maintained vehicles can be arranged for airport transfers, corporate travel, family trips, local destinations, and outstation journeys."
  },
  {
    "name": "Cheap Cab Service NMIA",
    "description": "Cheap Cab Service NMIA offers practical transportation options for passengers looking for budget-friendly airport travel. Suitable sedan and other vehicle options can be selected according to passenger count, luggage, destination, and travel requirements."
  },
  {
    "name": "24x7 Cab Service NMIA",
    "description": "24x7 Cab Service NMIA is suitable for passengers traveling during early mornings, late nights, and different flight schedules. Airport pickups, drops, local transfers, and outstation journeys can be arranged according to the required travel time."
  },
  {
    "name": "Pickup Cab at Navi Mumbai International Airport",
    "description": "Pickup Cab at Navi Mumbai International Airport provides convenient transportation for arriving passengers heading to hotels, homes, offices, railway stations, and other destinations. Spacious AC vehicles can be arranged for individuals, families, and groups."
  },
  {
    "name": "Drop Cab to Navi Mumbai International Airport",
    "description": "Drop Cab to Navi Mumbai International Airport helps travelers reach the airport comfortably from Navi Mumbai, Mumbai, Thane, Pune, and nearby locations. Vehicle options can be selected according to luggage, passenger count, and pickup location."
  },
  {
    "name": "NMIA Airport Pickup Taxi",
    "description": "NMIA Airport Pickup Taxi offers convenient private transportation for passengers arriving at Navi Mumbai International Airport. The service is suitable for hotel transfers, residential drops, corporate travel, family transportation, and outstation journeys."
  },
  {
    "name": "NMIA Airport Drop Cab",
    "description": "NMIA Airport Drop Cab provides scheduled transportation to Navi Mumbai International Airport from homes, offices, hotels, and other pickup points. Comfortable AC vehicles can be arranged for individual passengers, families, business travelers, and groups."
  },
  {
    "name": "Prepaid Cab NMIA",
    "description": "Prepaid Cab NMIA provides a convenient airport transportation option for passengers who prefer to arrange their cab requirements in advance. Suitable vehicles can be selected for airport pickups, drops, local transfers, corporate travel, and outstation journeys."
  },
  {
    "name": "Airport Transfer Cab NMIA",
    "description": "Airport Transfer Cab NMIA provides private transportation between Navi Mumbai International Airport and hotels, residences, offices, railway stations, and nearby cities. Sedan, SUV, Ertiga, and Innova options can be arranged for different passenger requirements."
  },
  {
    "name": "Innova Cab at Navi Mumbai International Airport",
    "description": "Innova Cab at Navi Mumbai International Airport is a spacious option for families, groups, corporate travelers, and passengers carrying multiple bags. The vehicle can be arranged for airport pickup, airport drop, local travel, and outstation transportation."
  },
  {
    "name": "Ertiga Cab NMIA",
    "description": "Ertiga Cab NMIA offers comfortable multi-passenger transportation for families and small groups traveling to or from the airport. It is suitable for airport transfers, local Navi Mumbai travel, business trips, and outstation journeys."
  },
  {
    "name": "Sedan Taxi NMIA",
    "description": "Sedan Taxi NMIA provides a comfortable and practical airport transfer option for individuals, couples, and small families. Sedan cars can be arranged for airport pickups, drops, hotel transfers, office travel, and intercity journeys."
  },
  {
    "name": "SUV Cab NMIA",
    "description": "SUV Cab NMIA provides spacious transportation for families, groups, and passengers carrying additional luggage. SUVs are suitable for airport transfers, corporate travel, weekend journeys, sightseeing, and outstation transportation from Navi Mumbai International Airport."
  },
  {
    "name": "AC Cab NMIA",
    "description": "AC Cab NMIA offers comfortable air-conditioned transportation for passengers traveling to and from Navi Mumbai International Airport. The service is suitable for airport transfers, local travel, business requirements, family trips, and long-distance journeys."
  },
  {
    "name": "Luxury Cab Navi Mumbai International Airport",
    "description": "Luxury Cab Navi Mumbai International Airport provides premium transportation for corporate executives, business travelers, special guests, and passengers seeking an enhanced travel experience. Premium vehicles can be arranged for airport transfers and intercity travel."
  },
  {
    "name": "Corporate Cab Service NMIA",
    "description": "Corporate Cab Service NMIA supports business transportation requirements including airport pickups, executive transfers, client travel, office journeys, meetings, and corporate events. Comfortable sedan, SUV, and premium vehicles can be arranged for professional travel."
  },
  {
    "name": "Business Travel Cab Navi Mumbai International Airport",
    "description": "Business Travel Cab Navi Mumbai International Airport is suitable for executives and professionals traveling for meetings, conferences, client visits, and corporate assignments. Scheduled airport pickups, drops, hotel transfers, and intercity transportation can be arranged."
  },
  {
    "name": "Office Pickup Drop Cab NMIA",
    "description": "Office Pickup Drop Cab NMIA provides convenient transportation for employees and business travelers traveling between offices, residences, hotels, and Navi Mumbai International Airport. Suitable vehicles can be arranged for individual employees, teams, and corporate requirements."
  }
],
"tableData": [
  ["Cab Service in Navi Mumbai International Airport", "Navi Mumbai International Airport Cab"],
  ["Navi Mumbai International Airport Taxi", "NMIA Cab Service"],
  ["NMIA Taxi Service", "Airport Cab Navi Mumbai International Airport"],
  ["Taxi Service at Navi Mumbai International Airport", "Navi Mumbai International Airport Cab Booking"],
  ["NMIA Taxi Booking Online", "Navi Mumbai International Airport Cab Fare"],
  ["NMIA Taxi Charges", "Navi Mumbai International Airport Cab Price"],
  ["Best Cab Service at NMIA", "Cheap Cab Service NMIA"],
  ["24x7 Cab Service NMIA", "Pickup Cab at Navi Mumbai International Airport"],
  ["Drop Cab to Navi Mumbai International Airport", "NMIA Airport Pickup Taxi"],
  ["NMIA Airport Drop Cab", "Prepaid Cab NMIA"],
  ["Airport Transfer Cab NMIA", "Innova Cab at Navi Mumbai International Airport"],
  ["Ertiga Cab NMIA", "Sedan Taxi NMIA"],
  ["SUV Cab NMIA", "AC Cab NMIA"],
  ["Luxury Cab Navi Mumbai International Airport", "Corporate Cab Service NMIA"],
  ["Business Travel Cab Navi Mumbai International Airport", "Office Pickup Drop Cab NMIA"]
]
,



whychoose: [
  {
    WhyChooseheading: "Navi Mumbai International Airport Cabs for Easy Airport Travel",
    WhyChoosedescription: "Private cabs for Navi Mumbai International Airport provide a convenient transportation option for passengers travelling for business, holidays, family visits, airport connections, and other domestic or international journeys."
  },
  {
    WhyChooseheading: "Convenient Pickup & Drop Arrangements",
    WhyChoosedescription: "Passengers can arrange airport pickup or drop from their preferred home, hotel, office, residential area, or another accessible location, making the journey easier to coordinate around flight schedules."
  },
  {
    WhyChooseheading: "Suitable for Domestic & International Travellers",
    WhyChoosedescription: "Private airport cabs can be arranged for passengers travelling on domestic or international flights, with transportation planned according to their departure or arrival requirements."
  },
  {
    WhyChooseheading: "Comfortable for Families & Groups",
    WhyChoosedescription: "Families, couples, and groups can select a suitable vehicle based on passenger numbers, luggage requirements, and comfort preferences for convenient airport transportation."
  },
  {
    WhyChooseheading: "Useful for Corporate Airport Transfers",
    WhyChoosedescription: "Business travellers can arrange private cabs for airport transfers connected with meetings, conferences, client visits, office assignments, and corporate travel requirements."
  },
  {
    WhyChooseheading: "Luggage-Friendly Airport Transportation",
    WhyChoosedescription: "Travellers carrying suitcases and other permitted luggage can select a vehicle according to passenger and baggage requirements for a more convenient journey between the airport and their destination."
  },
  {
    WhyChooseheading: "Travel Between Mumbai & Navi Mumbai",
    WhyChoosedescription: "Private cabs can be used for airport transportation between Navi Mumbai International Airport and preferred locations in Navi Mumbai, Mumbai, Thane, Pune, and other accessible destinations."
  },
  {
    WhyChooseheading: "Easy Booking with Garud Cab Service",
    WhyChoosedescription: "Provide your airport pickup or drop location, travel date, flight details when applicable, passenger count, luggage information, and preferred vehicle with Garud Cab Service for booking assistance."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Navi Mumbai International Airport Cabs?",
    answer: "Yes, Garud Cab Service provides private cab options for Navi Mumbai International Airport pickup and drop requirements for families, professionals, tourists, couples, students, and groups."
  },
  {
    question: "Can I book a cab to Navi Mumbai International Airport?",
    answer: "Yes, passengers can arrange a private cab from their preferred home, hotel, office, residential location, or another accessible pickup point to Navi Mumbai International Airport."
  },
  {
    question: "Can I book a pickup from Navi Mumbai International Airport?",
    answer: "Yes, arriving passengers can arrange private transportation from the airport to their preferred destination in Navi Mumbai, Mumbai, Thane, Pune, or another accessible location."
  },
  {
    question: "Are these cabs suitable for international flights?",
    answer: "Yes, private airport transportation can be arranged for passengers travelling on international as well as domestic flights according to their planned airport schedule."
  },
  {
    question: "Can families book Navi Mumbai International Airport cabs?",
    answer: "Yes, families and groups can choose a suitable vehicle based on passenger count, luggage quantity, and comfort requirements."
  },
  {
    question: "Can corporate travellers use the airport cab service?",
    answer: "Yes, business travellers can arrange private airport transfers for meetings, conferences, client visits, office assignments, and other corporate requirements."
  },
  {
    question: "Can I travel from Navi Mumbai International Airport to Mumbai?",
    answer: "Yes, private cabs can be arranged for direct transportation from Navi Mumbai International Airport to preferred destinations across Mumbai."
  },
  {
    question: "Can I book a cab from Pune to Navi Mumbai International Airport?",
    answer: "Yes, private airport transportation can be arranged from Pune to Navi Mumbai International Airport according to your travel date, flight schedule, passenger count, and vehicle requirement."
  },
  {
    question: "Can I carry luggage in the airport cab?",
    answer: "Yes, passengers can carry luggage according to the available capacity of the selected vehicle. Larger baggage requirements should be shared while booking."
  },
  {
    question: "How can I book Navi Mumbai International Airport Cabs?",
    answer: "Share your airport pickup or drop location, travel date, flight details when applicable, passenger details, luggage requirements, and preferred vehicle with Garud Cab Service."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Rajesh Patil",
    feedback: "I arranged a private cab for airport travel and found the direct pickup convenient for coordinating my journey with the flight schedule. The vehicle was also suitable for my luggage.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Komal Shah",
    feedback: "Our family used a private airport cab with several bags. Having a direct vehicle made the journey more convenient and allowed everyone to travel together comfortably.",
    rating: 5
  }
];





  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai International Airport Cabs",
  "image": "https://garudcabs.com/assets/images/navi-mumbai-international-airport-cabs.webp",
  "description": "Book Navi Mumbai International Airport Cabs with Garud Cab for safe, comfortable, and reliable airport transportation. Get cab and taxi services for airport pickup, airport drop, Mumbai transfers, Pune transfers, hotel transfers, business travel, and outstation journeys. Choose Sedan, Ertiga, SUV, Innova, and Innova Crysta vehicles with convenient booking and flexible travel options.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/navi-mumbai-international-airport-cabs"
  }
};




  return (
    <div>
<Helmet>
  <title>Navi Mumbai International Airport Cabs | NMIA Taxi | +91 9970007784</title>

  <meta
    name="description"
    content="Book Navi Mumbai International Airport Cabs with Garud Cab for reliable airport pickup, drop, Mumbai, Pune, hotel, and outstation transfers. Get comfortable Sedan, Ertiga, SUV, Innova, and Innova Crysta taxi options."
  />

  <meta
    name="keywords"
    content="Cab Service in Navi Mumbai International Airport, Navi Mumbai International Airport Cab, Navi Mumbai International Airport Taxi, NMIA Cab Service, NMIA Taxi Service, Airport Cab Navi Mumbai International Airport, Taxi Service at Navi Mumbai International Airport, Navi Mumbai Airport Cab Booking, NMIA Airport Transfer, Navi Mumbai International Airport Pickup Cab, Navi Mumbai International Airport Drop Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/108.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaiinternatinalairport;